module.exports = __webpack_public_path__ + "static/media/defaultAvatar14.23944b8c.svg";